export default __webpack_public_path__ + "static/media/ghost-person-dark.ede70f8b.svg";